/**
 * @description Simple generic spinner animation that can be resized
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Box from '@mui/material/Box';

const Spinner = ({ height, size, width }) => {
  const styles = {
    animation: 'rotateSpinner 800ms linear infinite',
    border: `${ size } solid #fff`,
    borderRightColor: '#276eae',
    borderRadius: '50%',
    height,
    width,

    '@keyframes rotateSpinner': {
      to: {
        transform: 'rotate(360deg)'
      }
    }
  };

  return (
    <Box sx={styles} />
  );
};

Spinner.propTypes = {
  height: PropTypes.string,
  size: PropTypes.string,
  width: PropTypes.string
};

Spinner.defaultProps = {
  height: '16px',
  size: '4px',
  width: '16px'
};

export default Spinner;
